import { render, staticRenderFns } from "./sydtgl.vue?vue&type=template&id=d15e89ec&scoped=true&"
import script from "./sydtgl.vue?vue&type=script&lang=js&"
export * from "./sydtgl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d15e89ec",
  null
  
)

export default component.exports